/**
 * App Component
 *
 * Main application component that combines providers and router
 */

import './styles';

import { AppProviders } from './providers';
import { AppRouter } from './router';
import { StrictMode } from 'react';

/**
 * App component
 *
 * Wraps the application with providers and renders the router
 */
export const App = () => {
  return (
    <StrictMode>
      <AppProviders>
        <AppRouter /> 
      </AppProviders>
    </StrictMode>
  );
};
